import { yupResolver } from '@hookform/resolvers/yup';
import { Send } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { PATHS } from '../../../../config/consts';
import { RouterLink } from '../Link/PrimaryLink';
import messages from './messages';
import { defaultValues, getEmailFormValidationSchema, IEmailFormData } from './validationScheme';

export interface IEmailFormProps {
  isDisabled: boolean;
  initEmail?: string;
  onSubmit: (values: IEmailFormData) => void;
}

export function EmailForm({ initEmail, isDisabled, onSubmit }: IEmailFormProps) {
  const { formatMessage } = useIntl();
  const formData = useForm<IEmailFormData>({
    defaultValues: initEmail ? { ...defaultValues, email: initEmail } : defaultValues,
    mode: 'onChange',
    resolver: yupResolver(getEmailFormValidationSchema(formatMessage)),
  });

  return (
    <FormProvider {...formData}>
      <form onSubmit={formData.handleSubmit((formValues: IEmailFormData) => onSubmit(formValues))}>
        <Stack spacing={1}>
          <OutlinedTextField
            data-testid="reset-password-email"
            label={<FormattedMessage {...messages.resetPasswordEmailLabel} />}
            name="email"
            required
            type="email"
            autoFocus
            fullWidth
          />
          <Button
            color="primary"
            data-testid="reset-password-submit"
            disabled={!formData.formState.isValid || isDisabled}
            fullWidth
            startIcon={<Send />}
            size="large"
            type="submit"
            variant="contained"
          >
            <FormattedMessage {...messages.resetPasswordSubmit} />
          </Button>
          <RouterLink styles={{ pt: 1 }} to={PATHS.LOGIN}>
            <FormattedMessage {...messages.resetPasswordBackToLogin} />
          </RouterLink>
        </Stack>
      </form>
    </FormProvider>
  );
}
